import styled from '@emotion/styled';

import Button from '../../../../styledComponents/UI/Button/Button';

export const StyledButton = styled(Button)`
  margin-top: 1.75rem;
  align-self: flex-start;
`;
